function scrollToSpecsTabPdp() {
    const specsSection = document.querySelector('.mr-pp-tabs[id="rr-pp-specs-table"]');
    const targetElement = specsSection.querySelector('.content-container');
    targetElement.classList.add('show');
    targetElement.style.display = 'block';
}

// ALP Functions Start
function updateJustifyBasedOnOverflow() {
    const elements = document.querySelectorAll('.justify-content-setter');

    elements.forEach(el => {
        if (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight) {
            el.style.justifyContent = 'flex-start';
        } else {
            el.style.justifyContent = 'center';
        }
    });
}

window.addEventListener('resize', updateJustifyBasedOnOverflow);
window.addEventListener('load', updateJustifyBasedOnOverflow);
// ALP Functions End
